module.exports = {"230521100":"福利镇","230521101":"集贤镇","230521102":"升昌镇","230521103":"丰乐镇","230521104":"太平镇","230521201":"腰屯乡","230521202":"兴安乡","230521204":"永安乡","230521401":"太平林场","230521402":"丰乐林场","230521403":"七星林场","230521404":"峻山林场","230521405":"爱林林场","230521406":"腰屯林场","230521407":"升平煤矿","230521480":"黑龙江省双鸭山监狱","230521500":"二九一农场","230521581":"良种场","230521582":"种畜场","230521583":"果树示范场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230521.json
// module id = 816
// module chunks = 0